<div class="collapsible-card">
  <button
    type="button"
    class="card-toggle"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
  >
    <div class="toggle-left">
      <app-icon [type]="IconType.MAIL" [size]="20"></app-icon>
      <span class="toggle-title">Kontakt</span>
    </div>
    <app-icon
      [type]="IconType.CHEVRON_DOWN"
      [size]="20"
      [class.rotated]="isExpanded()"
    ></app-icon>
  </button>

  @if (isExpanded()) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="section-form">
      <div class="form-group">
        <label for="contactEmail" class="form-label">Kontakt-E-Mail</label>
        <input
          id="contactEmail"
          type="email"
          formControlName="contactEmail"
          class="form-input"
          [class.has-change]="isFieldChanged('contactEmail')"
          placeholder="privat@beispiel.de"
          autocomplete="email"
        />
        @if (hasError('contactEmail', 'email')) {
          <span class="error-text">Bitte gib eine gültige E-Mail-Adresse ein</span>
        }
      </div>

      <div class="form-group">
        <label for="mobilePhone" class="form-label">Private Mobilnummer</label>
        <input
          id="mobilePhone"
          type="tel"
          formControlName="mobilePhone"
          class="form-input"
          [class.has-change]="isFieldChanged('mobilePhone')"
          placeholder="+49 170 1234567"
          autocomplete="tel"
        />
        @if (hasError('mobilePhone', 'pattern')) {
          <span class="error-text">Bitte eine gültige Telefonnummer eingeben</span>
        }
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="toggleExpanded()"
          [disabled]="isSaving()"
        >
          {{ hasChanges() ? 'Verwerfen' : 'Abbrechen' }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!form.valid || isSaving() || !hasChanges()"
          [class.btn-loading]="isSaving()"
        >
          @if (isSaving()) {
            Speichern...
          } @else {
            Speichern
          }
        </button>
      </div>
    </form>
  }
</div>
